import { Injectable } from '@angular/core';
import {
  idNameItem,
} from 'jk-service';
import { StktqServicePkg } from './stktqPkg.service';
import { Stktq } from '../entity/Stktq-angular';

/** 海期商品委託 */


@Injectable({
  providedIn: 'root',
})
export class StktqService extends StktqServicePkg {
  newItem: Stktq = this.getDefaultItem(); // new Stktq();

  // 0:ROD    1:FOK      2:IOC
  tq015List: idNameItem[] = [
    { id: '0', name: 'ROD' },
    { id: '1', name: 'FOK' },
    { id: '2', name: 'IOC' },
  ];
  // 0:LMT 限價單 1:MKT市價單  2:STL停損限價  3.STP 停損市價
  tq016List: idNameItem[] = [
    { id: '0', name: 'LMT' },
    { id: '1', name: 'MKT' },
    { id: '2', name: 'STL' },
    { id: '3', name: 'STP' },
  ];
  //tq008: number = 0;//委託價
  //tq017: number = 1; // 委託口數

  buysaleTitle: string = '';
  get buysale(): string {
    return this.newItem.TQ012.toString();
  }
  set buysale(value: string) {
    if (!value) return;
    this.newItem.TQ012 = parseInt(value);
    if (this.newItem.TQ012 === 0) {
      this.buysaleTitle = '確認買進';
    } else {
      this.buysaleTitle = '確認賣出';
    }
  }
  get tq015(): string {
    return this.newItem.TQ015.toString();
  }
  set tq015(value: string) {
    this.newItem.TQ015 = parseInt(value);
  }
  get tq016(): string {
    return this.newItem.TQ016.toString(); // 0:LMT 限價單 1:MKT市價單  2:STL停損限價  3.STP 停損市價
  }
  set tq016(value: string) {
    this.newItem.TQ016 = parseInt(value);
  }
  get tq014YN(): string {
    return this.newItem.TQ014 === 0 ? 'N' : 'Y';
  }
  set tq014YN(value: string) {
    if (typeof value === 'string') {
      this.newItem.TQ014 = value === 'N' ? 0 : 1;
    } else {
      console.error('set tg014YN value is not string');
    }
  }
  /*set tq005(value: string) {
    this.newItem.TQ005 = value;

  }
  get tq005(): string {
    return this.newItem.TQ005;
  }*/
  constructor() {
    super();
    this.defaultManagerField(this.newItem, true);
    this.newItem.TQ001 = this.nowDate();
    this.newItem.TQ012 = 0;
    this.newItem.TQ017 = 1;
  }
  async doBeforeSend(uId: string): Promise<boolean> {
    this.newItem.TQ018 = uId;
    this.newItem.TQ001 = this.nowDate();
    this.newItem.TQ027 = this.nowTime8();
    if (this.newItem.TQ008 === 0) {
      alert('委託價不能為0');
      return false;
    }
    let ret = await this.orm.autoNo(
      'data',
      this.tableName,
      this.keyFields.join(','),
      this.newItem.TQ001 + ',' + this.newItem.TQ002,
      this.newItem.TQ001
    );
    if (ret.result) {
      this.newItem.TQ003 = ret.data;
      let bool = this.checkRequiredFields(this.newItem, ret);
      if (!bool) return false;
    } else {
      alert('取序號錯誤:' + ret.message);
      return false;
    }
    return true;
  }
}
